
import CommonState from '@/class/cargo/model/parameters/CommonState'

export const CUSTOMFILE = new CommonState(1000, '报关', 'customInfo')
export const ORDERBACK = new CommonState(1001, '退单', 'orderBack')
export const WAREHOUSE = new CommonState(1002, '仓库', 'warehouse')
export const CONTRACT = new CommonState(1003, '合同', 'contract')
export const PARTNER = new CommonState(1004, '客户', 'partner')
export const SURCHARGEFCL = new CommonState(1005, '整箱附加费', 'surchargeFCL')
export const SURCHARGEAIR = new CommonState(1006, '空运附加费', 'surchargeAir')

export const DOCUMENTSOURCES = [CUSTOMFILE, ORDERBACK, WAREHOUSE]
